import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';


export const authRoutes: Routes = [
  {
    path: 'auth',
    children: [
      { path: 'login', component: LoginComponent }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/auth/auth.routes.ts